/** Map plan numbers to name */
const planNameMapping: Record<number, string> = {
	0: 'Free',
	10: 'Inform',
	20: 'Deluxe',
	21: 'Deluxe',
	30: 'Engage',
};

export default planNameMapping;
